import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import './footer.js'
import './header.js'

Alpine.plugin(intersect)
window.Alpine = Alpine
Alpine.start()

console.log('GardaHelp theme loaded');